export default __webpack_public_path__ + "static/media/marker-blue.339524fd.png";